import { ApiService } from "pwapi";

import { AsyncSagaActionNoArgs, createAsyncSaga } from "../utils/asyncActions";

export const GET_SITE_SPECIFIC_CODES_REQUEST =
  "@@settings/GET_SITE_SPECIFIC_CODES_REQUEST";
export const GET_SITE_SPECIFIC_CODES_SUCCESS =
  "@@settings/GET_SITE_SPECIFIC_CODES_SUCCESS";
export const GET_SITE_SPECIFIC_CODES_FAILURE =
  "@@settings/GET_SITE_SPECIFIC_CODES_FAILURE";

export const fetchSiteSpecificCodes = createAsyncSaga(
  GET_SITE_SPECIFIC_CODES_REQUEST,
  GET_SITE_SPECIFIC_CODES_SUCCESS,
  GET_SITE_SPECIFIC_CODES_FAILURE,
  () => "siteSpecificIcd10Code",
  () => ApiService.siteSpecificIcd10Code(),
  {
    skipDuplicates: true,
  }
) as AsyncSagaActionNoArgs;
